/* =====================================================================
 * WorkspaceModeShell — compatibility mode shell.
 *
 * Route-first hosts should use the concrete route layout components from
 * WorkspaceRouteLayouts. This shell remains for hosts that still delegate
 * page selection to WorkspaceRouter.
 * ===================================================================== */

import React from 'react';
import { WorkspaceModeChrome } from './WorkspaceModeChrome';
import { WorkspaceRouter } from './WorkspaceRouter';

export const WorkspaceModeShell: React.FC = () => (
  <WorkspaceModeChrome>
    {({ inputSlot }) => <WorkspaceRouter inputSlot={inputSlot} />}
  </WorkspaceModeChrome>
);
